/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Video_BodyInputs */

const en_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep-dive lesson with high-speed video and launch-monitor data. See exactly what your swing does, and what to change.`)
};

const es_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clase en profundidad con video de alta velocidad y datos de launch monitor. Mira exactamente qué hace tu swing y qué cambiar.`)
};

const de_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefenanalyse mit Highspeed-Video und Launch-Monitor-Daten. Sehen Sie genau, was Ihr Swing macht – und was Sie ändern sollten.`)
};

const zh_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结合高速视频与弹道监测仪数据的深度课程。清楚看到你的挥杆究竟发生了什么，以及需要改什么。`)
};

const ar_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس معمّق بفيديو عالي السرعة وبيانات جهاز تحليل الضربات. شاهد بالضبط ما يفعله السوينغ الخاص بك وما يجب تغييره.`)
};

const fr_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçon approfondie avec vidéo haute vitesse et données de launch monitor. Voyez exactement ce que fait votre swing et ce qu’il faut changer.`)
};

const vi_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học chuyên sâu với video tốc độ cao và dữ liệu máy đo quỹ đạo. Thấy chính xác swing của bạn làm gì và cần thay đổi gì.`)
};

const sw_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo la kina kwa video ya kasi ya juu na data ya launch monitor. Ona hasa swing yako inafanya nini, na nini cha kubadilisha.`)
};

const th_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนเชิงลึกด้วยวิดีโอความเร็วสูงและข้อมูลลอนช์มอนิเตอร์ เห็นชัดว่าสวิงของคุณทำอะไร และควรปรับอะไร`)
};

const bs_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dubinska lekcija s videozapisom velike brzine i podacima launch monitora. Vidite tačno šta vaš swing radi i šta promijeniti.`)
};

const ja_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイスピード映像とローンチモニターデータによる本格レッスン。スイングの実態と直すべき点がはっきり見えます。`)
};

const ko_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고속 영상과 론치 모니터 데이터로 하는 심화 레슨. 스윙이 실제로 하는 일과 바꿀 점이 정확히 보입니다.`)
};

const pt_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aula aprofundada com vídeo em alta velocidade e dados de launch monitor. Veja exatamente o que seu swing faz e o que mudar.`)
};

const it_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezione approfondita con video ad alta velocità e dati del launch monitor. Vedi esattamente cosa fa il tuo swing e cosa cambiare.`)
};

const sv_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fördjupad lektion med höghastighetsvideo och data från launch monitor. Se exakt vad din sving gör och vad du behöver ändra.`)
};

const nl_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diepgaande les met high-speed video en launchmonitordata. Zie precies wat je swing doet en wat je moet veranderen.`)
};

const da_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dybdegående lektion med højhastighedsvideo og launch monitor-data. Se præcis, hvad dit sving gør, og hvad du skal ændre.`)
};

const nb_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundig leksjon med høyhastighetsvideo og data fra launch monitor. Se nøyaktig hva svingen din gjør, og hva du bør endre.`)
};

const fi_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perusteellinen tunti suurnopeusvideon ja launch monitor -datan avulla. Näet tarkalleen, mitä swingisi tekee ja mitä pitää muuttaa.`)
};

const pl_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegółowa lekcja z szybkim nagraniem wideo i danymi z launch monitora. Zobacz dokładnie, co robi twój swing i co warto zmienić.`)
};

const ru_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Углублённый урок с высокоскоростной видеосъёмкой и данными launch monitor. Вы точно увидите, что происходит с вашим свингом и что нужно изменить.`)
};

const tr_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek hızlı video ve launch monitor verileriyle kapsamlı ders. Swing’inizin tam olarak ne yaptığını ve neyi değiştirmeniz gerektiğini görün.`)
};

const hi_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाई-स्पीड वीडियो और लॉन्च मॉनिटर डेटा के साथ विस्तृत पाठ। साफ़ देखें कि आपका स्विंग असल में क्या करता है और क्या बदलना है।`)
};

const id_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran mendalam dengan video berkecepatan tinggi dan data launch monitor. Lihat dengan tepat apa yang dilakukan ayunan Anda dan apa yang perlu diubah.`)
};

const ms_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran mendalam dengan video berkelajuan tinggi dan data launch monitor. Lihat dengan tepat apa yang dilakukan hayunan anda, dan apa yang perlu diubah.`)
};

const cs_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podrobná lekce s vysokorychlostním videem a daty z launch monitoru. Uvidíte přesně, co váš švih dělá a co změnit.`)
};

const el_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εις βάθος μάθημα με βίντεο υψηλής ταχύτητας και δεδομένα launch monitor. Δείτε ακριβώς τι κάνει το σβινγκ σας και τι πρέπει να αλλάξει.`)
};

const he_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור מעמיק עם וידאו במהירות גבוהה ונתוני launch monitor. ראו בדיוק מה הסווינג שלכם עושה ומה כדאי לשנות.`)
};

const af_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diepgaande les met hoëspoedvideo en launch monitor-data. Sien presies wat jou swaai doen en wat jy moet verander.`)
};

const hu_lessons_format_video_body = /** @type {(inputs: Lessons_Format_Video_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alapos, részletes óra nagysebességű videóval és launch monitor adatokkal. Pontosan látod, mit csinál a swinged, és min kell változtatni.`)
};

/**
* | output |
* | --- |
* | "Deep-dive lesson with high-speed video and launch-monitor data. See exactly what your swing does, and what to change." |
*
* @param {Lessons_Format_Video_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_video_body = /** @type {((inputs?: Lessons_Format_Video_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Video_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_video_body(inputs)
	if (locale === "de") return de_lessons_format_video_body(inputs)
	if (locale === "zh") return zh_lessons_format_video_body(inputs)
	if (locale === "ar") return ar_lessons_format_video_body(inputs)
	if (locale === "fr") return fr_lessons_format_video_body(inputs)
	if (locale === "vi") return vi_lessons_format_video_body(inputs)
	if (locale === "sw") return sw_lessons_format_video_body(inputs)
	if (locale === "th") return th_lessons_format_video_body(inputs)
	if (locale === "bs") return bs_lessons_format_video_body(inputs)
	if (locale === "ja") return ja_lessons_format_video_body(inputs)
	if (locale === "ko") return ko_lessons_format_video_body(inputs)
	if (locale === "pt") return pt_lessons_format_video_body(inputs)
	if (locale === "it") return it_lessons_format_video_body(inputs)
	if (locale === "sv") return sv_lessons_format_video_body(inputs)
	if (locale === "nl") return nl_lessons_format_video_body(inputs)
	if (locale === "da") return da_lessons_format_video_body(inputs)
	if (locale === "nb") return nb_lessons_format_video_body(inputs)
	if (locale === "fi") return fi_lessons_format_video_body(inputs)
	if (locale === "pl") return pl_lessons_format_video_body(inputs)
	if (locale === "ru") return ru_lessons_format_video_body(inputs)
	if (locale === "tr") return tr_lessons_format_video_body(inputs)
	if (locale === "hi") return hi_lessons_format_video_body(inputs)
	if (locale === "id") return id_lessons_format_video_body(inputs)
	if (locale === "ms") return ms_lessons_format_video_body(inputs)
	if (locale === "cs") return cs_lessons_format_video_body(inputs)
	if (locale === "el") return el_lessons_format_video_body(inputs)
	if (locale === "he") return he_lessons_format_video_body(inputs)
	if (locale === "af") return af_lessons_format_video_body(inputs)
	if (locale === "hu") return hu_lessons_format_video_body(inputs)
	return en_lessons_format_video_body(inputs)
});